import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { RootState } from '../../../../store/store';
import {
  UpdateUserProfileRequest,
  UserProfile,
} from '../../application/dto/UserProfile.dto';

const API_HOST = process.env.REACT_APP_API_HOST || '/v1/';
const API_BASE_URL = API_HOST.endsWith('/') ? API_HOST : `${API_HOST}/`;

const unwrapProfile = (response: { data?: UserProfile } | UserProfile): UserProfile => {
  if (response && typeof response === 'object' && 'data' in response && response.data) {
    return response.data;
  }
  return response as UserProfile;
};

export const settingsApi = createApi({
  reducerPath: 'settingsApi',
  baseQuery: fetchBaseQuery({
    baseUrl: API_BASE_URL,
    credentials: 'include',
    prepareHeaders: (headers, { getState }) => {
      const token = (getState() as RootState).auth?.accessToken;
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ['UserProfile'],
  endpoints: build => ({
    getProfile: build.query<UserProfile, void>({
      query: () => ({
        url: '/users/profile',
        method: 'GET',
      }),
      transformResponse: unwrapProfile,
      providesTags: ['UserProfile'],
    }),
    updateProfile: build.mutation<UserProfile, UpdateUserProfileRequest | FormData>({
      query: body => ({
        url: '/users/profile',
        method: 'PATCH',
        body,
      }),
      transformResponse: unwrapProfile,
      invalidatesTags: ['UserProfile'],
    }),
  }),
});

export const { useGetProfileQuery, useUpdateProfileMutation } = settingsApi;
